
import {
	Component,
	Vue,
	Watch
} from "vue-property-decorator";

import axios from 'axios';

import CollapseItem from '@/components/collapse.vue';
import PageFooter from '@/components/page-footer.vue';
import Switch from '@/components/switch.vue';
import SkuList from './components/sku-list.vue';
import UploadImg from '@/components/upload-img.vue';
import SelectRefundAddress from './components/select-refund-address.vue';
import Message from '@/components/message.vue';
import previewImg from '@/components/previewImg.vue';
import Dialog from '@/components/dialog.vue';
import cutarrow from '@/components/cutarrow.vue';
import importSpecificationCoding from './components/importSpecificationCoding.vue'
import draggable from 'vuedraggable'
import productPictures from './components/product-pictures.vue';

import chooseCoupon from '@/components/chooseCoupon.vue';
import quillconfig from '@/utils/quill-config-shop';
import {
	host,
	imgHost,
	maxspecifications
} from '@/utils/config';
import {
	productBuyerproductBuyerPageInit,
} from "@/api/supplier"
import {
	getOssToken
} from '@/api/user'
import {
	freightSettlementTemplatefreightSettlementTemplateList,
	ownBrandProductfilterBoxList,
	productClasslistTree
} from "@/api/order"
import {
	providerSelectItem,
	productInfo,
	createProduct,
	updateProduct,
	productUnitList,
	productCategory,
	productList,
	productproviderProductReCheckFail,
	productproviderProductReCheckPass,
	productImgTemplateList,
	checkPassAndHaveStatisticalNoProductList,
	productInfoByStatisticalNo,
	productChangeSpecAndJoinActivityOnePrice,
	productCrossBuyErpList
} from '@/api/supplier';
import {
	providerReturnAddressSelectItem,
	productfreightTemplateSelectitem
} from '@/api/logistics'

import {
	getTimestamp
} from '@/utils/index'
import html2canvas from 'html2canvas';
import {
	handleClipboard
} from '@/utils/clipboard'
import { Form } from "element-ui";

@Component({
	name: 'product-detail',
	components: {
		CollapseItem,
		PageFooter,
		'slz-switch': Switch,
		SkuList,
		UploadImg,
		SelectRefundAddress,
		'slz-message': Message,
		previewImg,
		'slz-dialog': Dialog,
		cutarrow,
		importSpecificationCoding,
		draggable,
		chooseCoupon,
		productPictures
	}
})
export default class ProductDetail extends Vue {
	private exchangeUrl = location.origin+'/image/server?url=';
	private arrowlist = [
		{ value: 0, label: '基本信息' },
		{ value: 1, label: '商品图文详情' },
	]
	private url = imgHost
	private type = this.$route.query.type;
	private isLook = false
	private isLook2 = this.$route.query.isLook2 ? true : false;
	private id = +this.$route.query.id;
	private isCheck = +this.$route.query.isCheck || 0;
	private search = ''
	private chooseTab = 0;
	private ProductInfo = {}
	private units: any = [];
	private selectVal = '';
	private isPageLoading = false;
	private showMessage = false;
	private categoryList: any = []; //商品分类
	private selectList = [{
		label: '内容',
		value: '值'
	}, {
		label: '内容2',
		value: '值2'
	}]
	private pickerOptions: any = {
		shortcuts: [{
			text: '今天',
			onClick(picker: any) {
				picker.$emit('pick', new Date());
			}
		}, {
			text: '昨天',
			onClick(picker: any) {
				const date = new Date();
				date.setTime(date.getTime() - 3600 * 1000 * 24);
				picker.$emit('pick', date);
			}
		}, {
			text: '一周前',
			onClick(picker: any) {
				const date = new Date();
				date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
				picker.$emit('pick', date);
			}
		}]
	}

	private needSelectShopIds = [3,8];

	private inputVisible = false;
	private inputValue = '';

	private hotData: any = [];
	private list: any = []
	private formData: any = {
		ProductName: '', // 商品名称,
		ProviderId: '', //所属供应商,
		BuyLimit: '', //购买限制,
		MinPurchase: '', //最低起购数
		ProductUnitId: '', // 单位Id,
		Sort: '', //排序
		OpenTime: '', // 上架时间,
		TakedownTime: '', //上架结束时间--下架时间,
		SpecTitle: '', // 规格1标题,
		SpecTitle2: '', // 规格2标题,
		SpecTitle3: '', // 规格3标题,
		SpecTitle4: '',
		SpecTitle5: '',
		FreightTemplateId: '', // 物流模板Id,
		ProviderReturnAddressId: '', // 退货地址Id,
		ProductTags: [], // 商品标签,
		RetailCheckTime: 72, // 零售审核时长,
		FirstRoleCheckTime: 72, // 联创审核时长,
		SecondRoleCheckTime: 72, //核心审核时长,
		ThirdRoleCheckTime: 72, //总代审核时长,
		ProductAuthPic: [], //产品资质授权书,
		ProductSixFaceImgUrl: [], //产品六面图,
		ProductThumbImgUrl: [], //产品封面图--遮罩,
		Video: [], //视频,
		ImgUrl: [], //商品主图,
		NoWatermarkImgUrl: [],//商品主图 无水印
		Details: [], //商品详情页,
		ProductSpecList: [], // 商品规格信息,
		SpecImgSelectLeve: -1, // 规格图选择的规格层级
		IsOpen: false, // 是否上架,
		IsCanCancel: true, //是否能取消,
		IsHaveOrderFee: true, // 是否含服务费
		CategoryIdList: [], // 商品分类
		sku: [
			{
				sku_name: '现货/预售',
				sku_info: [],
				Sort: 1,
			}
		],
		GoodsAmountMarginRate: 80, //商品货款质保金比例,
		GoodsAmountSettlePeriod: 60, //货款结算周期,
		MarginSettlePeriod: 60, //质保金结算周期,
		AfterSalePeriod: 30, //商品售后周期
		ProductType: 0,//0普通商品 1组合商品
		IsIncludedSubmitOrderInfo: false,//是否计入交单信息
		ProductMixInfoList: [],
		IsShareStock: false,
		SellPoint: '',
		ProductInfo: [],
		SpecBacthDataList: [],
		IsShowDataColumn: true,

		AgriculturalProductSalesReport: [],
		NonFarmProductSalesReport: [],
		LegitimateUser: [],
		HolderOfTradeMark: [],
		Trademark: '',
		TradeMarkRegistrationCertificate: [],
		AuthorizationDocuments: [],
		SupplementaryMaterial: [],
		IsOpenChangeProduct: true,
		IsOpenRefundProduct: true,
		IsOpenOnlyRefundMoney: true,
		IsNewExclusive: false,

		MainSpecSelectLeve: '',//主规格选择的规格层级
		AddressLimitQuantity: '',
		PhoneLimitQuantity: '',
		ProductNo: '',
		IsCrossBorderProduct: false,
		IsNewThirdRoleGradeExclusive: false,
		FreightSettlementTemplateId: '',
		TemplateName: '',
		FreightSettlementType: 1,
		FreightSettlementTemplateDetailList: [],
		IsCanSearch: true,

		SettlementType: 0,


		IsCanBuyFreightInsurance: false,
		CanSubmitOrderRoleGradeList: [1, 2, 3, 0],
		ProductBuyerId: null,
		IsPushCrossErp: false,
		ProductDetail: '',
		JoinActivityCouponList: [],

		IsExchangeBuyProduct: false,
		IsThroughZoneProduct: false,
		IsCanUseWaitDrawBalance: true,
		IsAutoSubmitApplyAuth: false,

		OwnBrandProductId: '',
		IsOpenDamageReshipment: false,
		ProductClassId: [],
		CrossErpType: '',
		CrossErpJKYunProductType: undefined,
		CrossErpEcinxProductType: undefined,
		HuiFuProductId: '',
		ProductImgTemplateId: null,
		SenderPhone: '',
		StatisticalNo: '',
		IsOpenProductRetrieval: false,
		TargetCollectionMoney: null
	}
	private formRule: any = {
		'ProductName': '请填写商品名',
		'ProviderId': '请选择供应商',
		'ProductClassId': '请选择商品类目',
		// 'Sort': '请输入排序数字',
		// 'ProductUnitId': '请选择单位',
		'OpenTime': '请选择开团时间',
		'TakedownTime': '请选择开团结束时间',
		'ProviderReturnAddressId': '请选择退货地址',
		// 'preorder_time': '请选择预告时间',
		// 'RetailCheckTime': '请输入零售审核时长',
		'ThirdRoleCheckTime': '请输入总代审核时长',
		'SecondRoleCheckTime': '请输入核心审核时长',
		'FirstRoleCheckTime': '请输入联创审核时长',
		'GoodsAmountMarginRate': '请设置质保金比例',
		'GoodsAmountSettlePeriod': '请设置货款结算周期',
		'MarginSettlePeriod': '请设置质保金结算周期',
		'AfterSalePeriod': '请设置商品售后周期'
	}
	private picRule: any = {
		// 'ProductAuthPic': '请上传产品资质&授权书',
		'ProductThumbImgUrl': '请上传封面图',
		'ImgUrl': '请上传商品主图',
	}
	private token: any = {}
	private skus: any = [{
		name: '', // 规格名
		list: []
	}]
	private skuDetail: any = []
	private skuNames: string[] = []
	private totalSku: any = {
		Stock: '', //库存
		Price: '', //原价
		GroupPrice: '', //团购价
		SpreadPrice: '', //差价
		ThirdRolePrice: '', //总代价
		RouTuanPrice: '', //肉团价
		lc_price: '',//联创
		core_price: '',//核心
	}
	private copytotalSku: any = {
		Stock: '', //库存
		Price: '', //原价
		GroupPrice: '', //团购价
		SpreadPrice: '', //差价
		ThirdRolePrice: '', //总代价
		RouTuanPrice: '', //肉团价
		lc_price: '',//联创
		core_price: '',//核心
	}
	private loadingSupplier = false;
	private supplierList: any = [];
	private showSelectRefundAddress = false;
	private selectRA: any = null;
	private isCover = false;
	private logisticsList: any = [];
	private logisticsList2: any = [];
	private canopengroup = false

	//最多添加规格数
	private specificationsNum = maxspecifications

	private searchName = ''
	private searchList: any = []
	private searchLoading = false
	private Shared = false
	private SharedDetail: any = []
	private SharedtotalSku: any = []
	private minnum = 0

	private explainShow = false

	private currentUrl = ''
	private showPreview = false
	private fileType = 'image'

	private checktype = 1
	private checkpassShow = false
	private checkrejectedShow = false
	private checkrejectedreason = ''
	private refuseResultVal = 1
	private refuseResult = [
		{
			label: '商品信息不全',
			value: 1
		}, {
			label: '商品规格不正确',
			value: 2
		}, {
			label: '商品类型违规',
			value: 3
		}, {
			label: '其他',
			value: 4
		}
	]
	//规格排序
	private changeDrag = false

	private isButtjoint = false
	private jushuitantips = false

	private novolume = false
	private importShow = false

	private errorTipsShow = false
	private errorType = 40000001
	private gradeList: any = [
		{
			label: '联创',
			value: 1
		}, {
			label: '核心',
			value: 2
		}, {
			label: '总代',
			value: 3
		}, {
			label: '客户(含提交注册团长信息的待审核用户)',
			value: 0
		}
	]
	private purchaselist: any = []

	private delTipShow = false
	private ShowOpenService = false
	private couponShow = false
	private editoroption: any = quillconfig
	private OwnBrandProductIdlist: any = []
	private categoryoptions: any = []
	private copyText: any = {}

	private homePageImgNorm = false
	private mainImgNorm = false
	private erpList = []
	private huiFuList = [
		{ value: '100200', label: '服饰箱包' },
		{ value: '100201', label: '食品药品' },
		{ value: '100202', label: '化妆品' },
		{ value: '100203', label: '电子产品' },
		{ value: '100204', label: '日用家居' },
		{ value: '100205', label: '其他' },
		{ value: '400200', label: '航空机票' },
		{ value: '400201', label: '酒店住宿' },
		{ value: '400202', label: '留学教育' },
		{ value: '400203', label: '旅游票务' },
		{ value: '400204', label: '国际物流' },
		{ value: '400205', label: '国际租车' },
		{ value: '400206', label: '国际会议' },
		{ value: '400207', label: '软件服务' },
		{ value: '400208', label: '医疗服务' },
		{ value: '400209', label: '通讯' },
		{ value: '400210', label: '休闲娱乐' },
		{ value: '228024', label: '广告服务' },
		{ value: '227020', label: '计算机服务' },
	]

	private queryLoading = false;
	private queryOptions = [];
	private queryKeywords = '';
	private resultLoading = true;
	private searchProductData = {}
	private isSearch = false;

	private templates = [];
	private showPreviewMainImage = false;
	private isReady = false;

	private skuChangeTips = false;
	private activityName = '';

	private shopList = []
	
	get templateUrl(){
		if (!this.formData.ProductImgTemplateId) return;
		let url = '';
		this.templates.map(item=>{
			if (item.Id === this.formData.ProductImgTemplateId){
				url = this.url + item.TemplateWatermarkImgUrl;
			}
		})
		return url;
	}

	@Watch('formData.CrossErpType')
	private CrossErpTypeChange(newd, oldd){
		// if (this.formData.CrossErpType === 8){
		// 	this.shopList = [
		// 		{ value: 1, label: 'Movefree氨糖' },
		// 		{ value: 2, label: '馨羽swisse' },
		// 		{ value: 3, label: 'GNITE跨境' }
		// 	]
		// }else if (this.formData.CrossErpType === 3){
		// 	this.shopList = [
		// 		{ value: 1, label: '义乌市融源公司' },
		// 		{ value: 2, label: '圣高体育' }
		// 	]
		// }
		this.shopList = [];
		this.erpList.map(item=>{
			if (item.Id === this.formData.CrossErpType && item.ShopList){
				this.shopList = item.ShopList.map(obj=>{
					return {
						value: obj.ShopId,
						label: obj.ShopName
					}
				})
			}
		})
	}

	@Watch('formData.NoWatermarkImgUrl')
	private imgUrlChange(newd, oldd){
		if (!this.isReady) return;
		this.formData.ImgUrl = JSON.parse(JSON.stringify(this.formData.NoWatermarkImgUrl));
		if (this.formData.NoWatermarkImgUrl.length && this.templateUrl){
			// setTimeout(this.getCanvasImage, 500)
		}
	}
	@Watch('templateUrl')
	private templateChange(newd, oldd){
		if (!this.isReady) return;
		if (!newd){
			this.formData.ImgUrl[0] = this.formData.NoWatermarkImgUrl[0];
		}
		// console.log('templateChange')
		if (this.formData.NoWatermarkImgUrl.length && this.templateUrl){
			// setTimeout(this.getCanvasImage, 500)
			// this.getCanvasImage();
		}
	}

	private async mounted() {
		// this.getToken();
		this.getERPList();
		await this.getSupplierList();
		await this.getproductClassfilterBoxList()
		this.getCategoryList();
		this.getUnits();
		this.getpurchaseList()
		this.getOwnBrandProductIdlist()
		
		await this.getImageTemplate();
		if (this.id) {
			this.isPageLoading = true;
			await this.getInfo();

			let msg = this.supplierList.find(v => v.Id == this.formData.ProviderId)
			this.isButtjoint = msg?.IsUserJuShuiTan || false
			// console.log(this.formData.ProductType)
		}

		if (!this.id || this.type == 'copy'){
			this.templates.map(item=>{
				if (item.IsDefault){
					this.formData.ProductImgTemplateId = item.Id;
				}
			})
		}
		// console.log(this.isLook, 'isLook')
		setTimeout(()=>{
			this.isReady = true;
		},500)
	}

	private async getERPList(){
		try {
			const res = await productCrossBuyErpList({});
			this.erpList = res.Result.map(item=>{
				return { Id: item.CrossErpType, label: item.CrossErpTypeValue, ...item }
			})
		} catch (error) {

		} finally {
		}
	}

	private getCanvasImage(){
		return new Promise((resolve, reject)=>{
			html2canvas(document.querySelector('#canvasBox'), {
				useCORS: true, // 【重要】开启跨域配置
				scale: 2,
				allowTaint: true, // 允许跨域图片
				logging: false,
			}).then((canvas) => {
				let canvasUrl = canvas.toDataURL('image/png')
				axios.post( host + '/api/image/upload?PlatForm=routuan&Path=image', {Images: [canvasUrl]}).then(res => {
					let dt = res.data;
					resolve(dt.Result[0]);
				}).catch(err => {
					reject(false);
					console.log('上传失败',err);
				})
			});
		})
			
	}

	private handlePreviewTemplate(){
		if (!this.formData.ProductImgTemplateId){
			this.$message.error('请选择模板');
			return;
		}
		if (!this.formData.ImgUrl.length){
			this.$message.error('请先上传主图');
			return;
		}
		this.showPreviewMainImage = true;
	}

	private async getImageTemplate() {
		try {
			let res = await productImgTemplateList({})
			this.templates = res.Result;
		} finally {
			//
		}
	}

	private productPicturesUpdate(list) {
		this.formData.Details = list;
	}

	private querySelectChange(){
		this.queryKeywords = this.formData.StatisticalNo;
		if(this.formData.StatisticalNo){
			this.searchProductInfoFromStatisticalNo();
		}else{
			this.isSearch = false;
		}
	}
	private async querySearchAsync(keywords) {
		// console.log(keywords)
		this.queryKeywords = keywords;
		this.queryLoading = true;
		try {
			const res = await checkPassAndHaveStatisticalNoProductList({Keywords: keywords, Skip: 0, Take: 99999});
			this.queryOptions = res.Result.Results;
			// callback(list)
		} catch (error) {

		} finally {
			this.queryLoading = false;
		}
	}
	private async searchProductInfoFromStatisticalNo(){
		this.isSearch = true;
		this.resultLoading = true;
		try {
			const res = await productInfoByStatisticalNo({StatisticalNo: this.formData.StatisticalNo, ProductId: this.id});
			this.searchProductData = res.Result;
			// callback(list)
		} catch (error) {

		} finally {
			this.resultLoading = false;
		}
	}
	private querySelectBlur(e){
		// console.log(this.formData.StatisticalNo,this.queryKeywords)
		// if (!this.formData.StatisticalNo && this.queryKeywords){
		// 	this.formData.StatisticalNo = this.queryKeywords;
		// }
		this.formData.StatisticalNo = this.queryKeywords;
		this.$nextTick(()=>{
			this.querySelectChange();
		})
	}
	private handleQueryBlur(){
		this.formData.StatisticalNo = this.queryKeywords;
		const ref: any = this.$refs['queryBox'];
		ref.blur();
		this.$nextTick(()=>{
			this.querySelectChange();
		})
	}
	private queryClear(){
		this.queryKeywords = '';
		this.queryOptions = [];
	}

	private changeCrossErpType(e) {
		if (e) {
			this.formData.IsPushCrossErp = true
		} else {
			this.formData.IsPushCrossErp = false
		}
	}
	private changeIsCrossBorderProduct(e) {
		// this.formData.IsPushCrossErp = e
		if (!e) {
			this.formData.CrossErpType = ''
			this.formData.HuiFuProductId = ''
			this.formData.IsPushCrossErp = false
		}
	}
	private showLookImg(url, type) {
		this.currentUrl = url
		this.fileType = type
		this.showPreview = true
	}
	private downFile(file) {
		const url = file
		let iframe = document.createElement('iframe')
		iframe.id = new Date().getTime().toString()
		iframe.style.display = "none"
		document.body.appendChild(iframe)
		iframe.src = url;
	}
	private checkChangeShowImg(e, m, n) {
		if (!e) return
		let length = this.formData.ProductInfo.reduce((pre, cur) => {
			if (cur.IsShowOnImg) {
				pre += 1
			}
			return pre
		}, 0)
		if (length > 5) {
			this.$message.error('为了兼容简图样式最多显示5项商品信息')
			this.formData.ProductInfo[n].IsShowOnImg = false
			return
		}
	}
	private saveInfoImg() {
		this.tocopy('', false)
		this.$nextTick(() => {
			html2canvas(document.querySelector('#infoImg'), {
				useCORS: true, // 【重要】开启跨域配置
				scale: 2,
				allowTaint: true, // 允许跨域图片
				logging: false,
			}).then((canvas) => {
				let canvasUrl = canvas.toDataURL('image/png')

				var a: any = document.createElement("a");

				var event = new MouseEvent("click");

				a.download = new Date().getTime() + '.png';

				a.href = canvasUrl;

				a.dispatchEvent(event);
			});
		})
	}
	private tocopy(e, copy) {
		let text = ''
		let price = '【市场零售价格】'
		let group = '【肉团团购价格】'
		this.copyText = {
			price: '',
			group: '',
			info: []
		}
		let allprice = 0
		let allgroup = 0
		let SpecValuelist = []
		this.skuDetail.map(v => {
			if (!SpecValuelist.some(x => x.SpecValue == v.SpecValue)) {
				SpecValuelist.push({
					SpecValue: v.SpecValue,
					price: '',
					group: '',
				})
			}
			SpecValuelist = SpecValuelist.map(x => {
				if (x.SpecValue == v.SpecValue) {
					if (!x.price || v.Price < x.price) {
						x.price = v.Price
						allprice += Number(v.Price * 100)//乘100防止小数有精度丢失的问题
					}
					if (!x.group || v.GroupPrice < x.group) {
						x.group = v.GroupPrice
						allgroup += Number(v.GroupPrice * 100)
					}
				}
				return x
			})
		})
		if (allprice == SpecValuelist[0].price * SpecValuelist.length * 100) {
			if (this.formData.IsIncludedSubmitOrderInfo) {
				SpecValuelist.map((x, i) => {
					price += `${'￥' + x.price}/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`
					this.copyText.price += `${'￥' + x.price}/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`
				})
			} else {
				price += '￥' + SpecValuelist[0].price
				this.copyText.price = '￥' + SpecValuelist[0].price
			}
		} else {
			if (this.formData.IsIncludedSubmitOrderInfo) {
				SpecValuelist.map((x, i) => {
					price += `${'￥' + x.price}/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`

					this.copyText.price += '￥' + x.price
					this.copyText.price += `/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`
				})
			} else {
				let list = this.skuDetail.map(v => v.Price)
				let min = Math.min(...list)
				let max = Math.max(...list)
				price += `${'￥' + min}~${'￥' + max}`
				this.copyText.price += `${'￥' + min}~${'￥' + max}`
			}
		}
		if (allgroup == SpecValuelist[0].group * SpecValuelist.length * 100) {

			if (this.formData.IsIncludedSubmitOrderInfo) {
				SpecValuelist.map((x, i) => {
					group += `${'￥' + x.group}/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`
					this.copyText.group += `${'￥' + x.group}/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`
				})
			} else {
				group += '￥' + SpecValuelist[0].group
				this.copyText.group = '￥' + SpecValuelist[0].group
			}
		} else {
			if (this.formData.IsIncludedSubmitOrderInfo) {
				SpecValuelist.map((x, i) => {
					group += `${'￥' + x.group}/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`

					this.copyText.group += '￥' + x.group
					this.copyText.group += `/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`
				})
			} else {
				let list = this.skuDetail.map(v => v.GroupPrice)
				let min = Math.min(...list)
				let max = Math.max(...list)
				group += `${'￥' + min}~${'￥' + max}`
				this.copyText.group += `${'￥' + min}~${'￥' + max}`
			}
		}

		text += price + '\n'
		text += group + '\n'
		this.formData.ProductInfo.map(v => {
			text += `【${v.InfoName}】`
			text += `${v.InfoContent}\n`
			this.copyText.info.push(`【${v.InfoName}】${v.InfoContent}`)
		})
		if (!copy) return
		handleClipboard(text, e)
	}
	private async getproductClassfilterBoxList() {
		try {
			let res = await productClasslistTree({})
			if (res.IsSuccess) {
				this.categoryoptions = res.Result.map(v => {
					if (!v.SecondProductClassDtos || !v.SecondProductClassDtos.length) {
						v.children = undefined
						return v
					} else {
						v.children = v.SecondProductClassDtos.map(x => {
							if (!x.ThirdProductClassDtos || !x.ThirdProductClassDtos.length) {
								x.children = undefined
								return x
							}
							x.children = x.ThirdProductClassDtos.length ? x.ThirdProductClassDtos : undefined
							return x
						})
						return v
					}
				})
			}
		} finally {
			//
		}
	}
	private async getOwnBrandProductIdlist() {
		try {
			let res = await ownBrandProductfilterBoxList({})
			if (res.IsSuccess) {
				this.OwnBrandProductIdlist = res.Result
			}
		} finally {
			//
		}
	}
	private changeIsThroughZoneProduct(e) {
		if (e) {
			this.$message.success('请自行配置好直通区商品的相关下单限制！')
		} else {
			this.formData.IsAutoSubmitApplyAuth = e

		}
	}
	private changeIsExchangeBuyProduct(e) {
		this.formData.IsCanSearch = !e
		if (e) {
			this.$message.warning('换购商品不允许被搜索，已默认关闭被搜索配置')
		} else {
			this.$message.warning('已打开被搜索配置')
		}
	}
	private clearCouponList(i) {
		this.formData.JoinActivityCouponList.splice(i, 1)
	}
	private getcouponData(list) {
		this.formData.JoinActivityCouponList = list.map(v => {
			return {
				Id: v.Id,
				CouponName: v.CouponName
			}
		})
		this.couponShow = false
	}
	private async getpurchaseList() {
		try {
			let res: any = await productBuyerproductBuyerPageInit({
				Skip: 0,
				Take: 999999
			})
			if (res.IsSuccess) {
				this.purchaselist = res.Result.Results
			}
		} finally {
			//
		}
	}
	private getSettlementTemplate(e) {
		let msg = this.logisticsList2.find(v => v.Id == e)
		// console.log(msg)
		if (msg && msg.Id) {
			this.formData.TemplateName = msg.TemplateName
			this.formData.FreightSettlementType = msg.FreightSettlementType
			this.formData.FreightSettlementTemplateDetailList = msg.DetailList
		}

	}
	private importclose() {
		this.importShow = false
		this.skuNames = []
		this.getInfo()
	}
	private exportSpecification() {
		let url = location.origin + '/pc/product/productSpecExport?ProductId=' + this.$route.query.id
		window.open(url)
	}
	private saveDrag() {
		// console.log(this.formData.sku)
		let sortlist = this.formData.sku.map(v => v.Sort).sort((a, b) => { return a - b })
		for (let index in sortlist) {
			if (!sortlist[index]) {
				this.$message.error('请完善规格的序号值')
				return false
			}
			else if (sortlist[index] != (Number(index) + 1)) {
				this.$message.error('层级必须是从1开始的连续的序号')
				return false
			}
		}
		this.formData.sku = this.formData.sku.sort((a, b) => { return a.Sort - b.Sort })
		this.formData.sku.map((v, i) => {
			v.sku_info && v.sku_info.length && v.sku_info.map(x => {
				if (x.pic_url) {
					this.formData.SpecImgSelectLeve = i
					return
				}
			})
		})
		this.skuNames = this.formData.sku.map(v => v.sku_name)
		this.changeDrag = false
		this.bunch({})
	}
	private cancelDrag() {
		this.formData.sku = this.formData.sku.map((v, i) => {
			v.Sort = i + 1
			return v
		})
		this.changeDrag = false
	}

	private cancelrejected() {
		this.checkrejectedShow = false
		this.checkrejectedreason = ''
		this.refuseResultVal = 1
	}
	async checkrefer(num) {
		try {
			let data: any = {
				ProductId: this.$route.query.id
			}
			if (num == 2) {
				if (!this.refuseResultVal) {
					this.$message.error('请选择驳回类型')
					return
				} else if (!this.checkrejectedreason) {
					this.$message.error('请输入驳回原因')
					return
				}
				data.ProductRejectType = this.refuseResultVal
				data.ProductRejectReason = this.checkrejectedreason
			}
			let res
			if (num == 1) {
				res = await productproviderProductReCheckPass(data)
			} else if (num == 2) {
				res = await productproviderProductReCheckFail(data)
			}
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.toBack()
			}
		} finally {
			//
		}
	}

	private tocheck(num) {
		this.checktype = 1
		if (num == 1) {
			this.checkpassShow = true
		} else if (num == 2) {
			this.checkrejectedShow = true
		}
	}

	private reviewsample(name) {
		this.currentUrl = 'https://cdn2024.routuan.com/routuan/image/' + name + '.jpg'
		this.showPreview = true
		this.fileType = 'image'
	}
	private downloadtemplate(name) {
		let filename = ''
		if (name == 'AgriculturalProductSalesReport') {
			filename = '产品销售声明（销售方、生产方）.docx'
		} else if (name == 'NonFarmProductSalesReport') {
			filename = '产品销售声明（经销商）.docx'
		} else if (name == 'LegitimateUser') {
			filename = '产品销售声明（合法使用者）.docx'
		} else if (name == 'HolderOfTradeMark') {
			filename = '产品销售声明（商标持有者）.docx'
		} else if (name == 'AuthorizationDocuments') {
			filename = '品牌授权书.docx'
		}
		let url = 'https://xsoss2016.oss-cn-hangzhou.aliyuncs.com/routuan/file/' + encodeURIComponent(filename)
		let a = document.createElement('a')
		a.href = url
		a.download = filename
		a.style.display = 'none'
		document.body.appendChild(a)
		a.click()
		document.body.removeChild(a)
	}

	private showSelectRefund() {
		// console.log(1)
		if (!this.formData.ProviderId) {
			this.$message('请选择供应商');
			return;
		}
		this.showSelectRefundAddress = true;
	}

	private changescroll() {
		this.$nextTick(() => {
			let errdiv = document.getElementsByClassName('page-container-inside')
			// console.log(errdiv[0].scrollTop)
			errdiv[0].scrollTop = 0
		})
	}

	private SharedStock(e, i) {
		if (!this.formData.IsShareStock) return
		let num = this.SharedDetail[e][i].Stock
		this.SharedDetail.map(v => {
			v.map((x, y) => {
				if (y == i) {
					x.Stock = num
				}
				return x
			})
			return v
		})
		// console.log(num.Stock)
	}
	private pushProductInfo() {
		this.formData.ProductInfo.push({
			InfoName: '',
			InfoContent: '',
			IsShowOnImg: false,
		})
	}

	private delProductInfo(i) {
		this.formData.ProductInfo.splice(i, 1)
	}

	private changeShared(e) {
		this.formData.IsShareStock = e
		this.bunch({})
	}


	private async bunch(obj: any) {
		let arr = JSON.parse(JSON.stringify(this.formData.sku))
		// console.log(arr)
		let num = 0
		let list = []
		if (arr.length == 1) {
			arr.map(v => {
				v.sku_info.map(x => {
					list.push([x])
				})
			})
		}
		//规格只有一个的时候不会走这个循环 所以上面直接赋值就行
		for (let i = 0; i < arr.length - 1; i++) {
			if (i + 1 >= arr.length) break
			let a: any = this.combo(arr[i], arr[i + 1], i)
			// console.log(a,'a')
			//拼接完成之后将前一个数据替换掉 再与后面还没拼接的数据继续拼接
			arr.splice(i + 1, 1, { sku_info: a })
			num++
			if (num >= arr.length - 1) {
				list = a
			}
		}
		// console.log(list,'list')
		let detaillist = list.map(v => {
			let data: any = {
				ImgUrl: v.find(x => x.pic_url)?.pic_url || '',
				Id: 0,
				preorder_num: 0,
				sales_amount: 0,
				core_price: '', //核心价
				lc_price: '', //联创价
				SellCount: 0, //销量
				Price: '', //原价
				Stock: '', //库存
				GroupPrice: '', //团购价
				ThirdRolePrice: '', //总代价
				SpreadPrice: '', //差价
				RouTuanPrice: '', //肉团价
				Count: '',
				IsCanSubmitOrder: true,
				ProductSpecNo: '',
				SaleCoefficient: 1,
			}
			v.map((x, i) => {
				let key = 'SpecValue' + (i == 0 ? '' : i + 1)
				data[key] = x.sku_value
				data.classKey = ''
				data.classKey += x.classKey
				//只有一个规格会有数据
				// console.log(this.formData.IsShareStock)
				// console.log(x)
				if (this.formData.IsShareStock && i == 0) {
					data.Count = x.Count
					data.IsCanSubmitOrder = x.IsCanSubmitOrder
				}
			})
			// console.log(data)
			return data
		})
		//如果是计入交单信息 把没有计入交单信息的数据的批量设置清空 
		//在getshardlist()里统一对所有数据为0的数据批量赋值 如果没有清空则不存在所有数据为0的
		if (this.formData.IsIncludedSubmitOrderInfo) {
			this.totalSku = {
				Stock: '', //库存
				Price: '', //原价
				GroupPrice: '', //团购价
				SpreadPrice: '', //差价
				ThirdRolePrice: '', //总代价
				RouTuanPrice: '', //肉团价
				lc_price: '',//联创
				core_price: '',//核心
			}
		} else {
			//两个数据一样的 如果清空了 再取回来
			this.totalSku = this.copytotalSku
		}
		// console.log(detaillist)
		if (obj.changetype == 1) {
			this.skuDetail = await this.oldlistChangetitle(obj, detaillist)
		} else {
			this.skuDetail = await this.assignment(detaillist, obj)
		}

		//计入交单信息
		if (this.formData.IsIncludedSubmitOrderInfo) {
			let SharedDetail: any = []
			SharedDetail = await this.getshardlist(this.skuDetail, obj)
			this.SharedDetail = SharedDetail
		}
		// console.log(this.skuDetail)
		// console.log(this.SharedDetail.map(v=>v.map(x=>x.isShowNumInput)),111)
	}
	//如果设置了共享库存 则需要改变商品详情的数组结构
	private getshardlist(list: any, obj: any) {
		let sku = JSON.parse(JSON.stringify(this.formData.sku))
		// console.log(sku)
		// console.log(Math.min(...sku[0].sku_info.map(v=>v.Count)))
		// this.SharedtotalSku = []
		let minnum = Math.min(...sku[0].sku_info.map(v => v.Count || 0))
		this.minnum = minnum
		let newlist: any = []
		sku[0].sku_info.map((v, i) => {
			let data: any = []
			list.map(x => {
				if (x.SpecValue == v.sku_value) {
					// console.log(v)
					x.Count = v.Count
					x.IsCanSubmitOrder = v.IsCanSubmitOrder || false
					x.isShowNumInput = (minnum != 0 && minnum == v.Count)
					// console.log(x)
					//看bunch()批量设置清空
					if (!x.Stock && !x.Price && !x.GroupPrice && !x.SpreadPrice && !x.ThirdRolePrice && !x.RouTuanPrice) {
						for (let key in this.SharedtotalSku[i]) {
							let xkey = key.substring(9, key.length)
							x[xkey] = this.SharedtotalSku[i][key]
							if (key == 'SpecBacthSecondRolePrice') {
								x.core_price = this.SharedtotalSku[i]['SpecBacthSecondRolePrice']
							} else if (key == 'SpecBacthFirstRolePrice') {
								x.lc_price = this.SharedtotalSku[i]['SpecBacthFirstRolePrice']
							}
						}
						// x.RouTuanPrice = parseFloat((x.SpreadPrice - x.SpreadPrice).toFixed(2))
					}
					data.push(x)
				}
			})
			if (!this.SharedtotalSku[i]) {
				let batch: any = {
					SpecBacthStock: '', //库存
					SpecBacthSellCount: '',//数量
					SpecBacthPrice: '', //原价
					SpecBacthGroupPrice: '', //团购价
					SpecBacthSpreadPrice: '', //差价
					SpecBacthThirdRolePrice: '', //总代价
					SpecBacthRouTuanPrice: '', //肉团价
				}
				this.SharedtotalSku.push(batch)
			}
			newlist.push(data)
		})

		return newlist
	}
	//如果是修改规格名称 则不会改变表格内的数量 所以按顺序赋一遍值就行了
	private oldlistChangetitle(obj: any, list: any) {
		let oldlist = JSON.parse(JSON.stringify(this.skuDetail))
		return list.map((v, i) => {
			for (let key in v) {
				// console.log(key)
				//除了规格型号的值 全替换成原来的数据
				if (key.indexOf('SpecValue') == -1) {
					v[key] = oldlist[i][key]
				}
			}
			return v
		})
	}
	//每次传入两个数组互相拼接
	private combo(arr1: any, arr2: any, num: number) {
		let newarr = []
		arr1.sku_info.map(v => {
			arr2.sku_info.map(x => {
				if (num == 0) {//第一次的时候v是个字符串
					newarr.push([v, x])
				} else {//第一次之后就是一个字符串数组
					newarr.push([...v, x])
				}

			})
		})
		return newarr
	}

	private assignment(detaillist: any, msg: any) {
		let sku = JSON.parse(JSON.stringify(this.formData.sku))
		let oldlist = JSON.parse(JSON.stringify(this.skuDetail))
		let list: any = []
		// console.log(oldlist,123)
		// console.log(sku)
		detaillist.map(async (j: any, ind: number) => {
			// console.log(this.findoldVal(detaillist,j),ind)
			let obj = await this.findoldVal(detaillist, j)
			// console.log(obj,'obj',j,'j')
			//如果在原数据中没有找到老的数据 对象为空
			//因为新增的数据跟老数据没有太大差别 在下一次新增时 上一个新增的会成为老数据 所以不用id判断
			//删除的时候也直重新算新数据
			if (Object.keys(obj).length == 0 || msg.IsDel) {
				let ThirdRolePrice = this.totalSku.ThirdRolePrice //总代价
				let SpreadPrice = this.totalSku.SpreadPrice //差价
				let core_price = this.totalSku.core_price //核心价
				let lc_price = this.totalSku.lc_price //联创价
				let oldmsg = this.getpicurl(j)
				// console.log(oldmsg,'oldmsg')
				let data: any = {
					ImgUrl: j.ImgUrl,
					Id: 0,
					preorder_num: 0,
					sales_amount: 0,
					core_price: core_price, //核心价
					lc_price: lc_price, //联创价
					SellCount: 0, //销量
					Price: this.totalSku.Price, //原价
					Stock: this.totalSku.Stock, //库存
					GroupPrice: this.totalSku.GroupPrice, //团购价
					ThirdRolePrice: this.totalSku.ThirdRolePrice, //总代价
					SpreadPrice: this.totalSku.SpreadPrice || '', //差价
					// RouTuanPrice:this.totalSku.RouTuanPrice, //肉团价  列表上这一列注释了，这里新增就不赋值了，不然老数据有问题
					Count: j.Count,
					IsCanSubmitOrder: j.IsCanSubmitOrder,
					ProductSpecNo: '',
					SaleCoefficient: 1
				}
				sku.map((v, i) => {
					let key = 'SpecValue' + (i == 0 ? '' : i + 1)
					data[key] = j[key]
				})
				// console.log(this.totalSku)
				// console.log(data,'data')
				list.push(data)
			} else {
				obj.ImgUrl = j.ImgUrl
				obj.Count = j.Count
				obj.IsCanSubmitOrder = j.IsCanSubmitOrder
				// console.log(obj,j,'else')
				list.push(obj)
			}
		})

		return list
	}
	//新增型号的时候会有没有改变的数据
	private findoldVal(newlist: any, newval: any) {
		let oldlist = JSON.parse(JSON.stringify(this.skuDetail))
		let sku = JSON.parse(JSON.stringify(this.formData.sku))
		// console.log(this.formData.sku,123)
		let oldvalue: any = {}
		old: for (let i = 0; i < oldlist.length; i++) {
			let num = 0
			sku: for (let x = 0; x < sku.length; x++) {
				let key = 'SpecValue' + (x == 0 ? '' : x + 1)
				// console.log(key)
				if (oldlist[i][key] === newval[key]) {
					num += 1
					continue sku
				}
			}
			if (num == sku.length) {
				oldvalue = oldlist[i]
				break old
			}
		}
		return oldvalue
	}
	//这里找到对应数据对应的规格信息 查找图片
	private getpicurl(newval: any) {
		// console.log(newval)
		let sku = JSON.parse(JSON.stringify(this.formData.sku))
		let list: any = []
		for (let i = 0; i < sku.length; i++) {
			for (let y = 0; y < sku[i].sku_info.length; y++) {
				let key = 'SpecValue' + (i == 0 ? '' : i + 1)
				if (newval[key] === sku[i].sku_info[y].sku_value) {
					list.push(sku[i].sku_info[y])
					break
				}
			}
		}
		return list
	}


	private clearSearch() {
		this.searchName = ''
		this.searchShop('')
	}

	private getIsIncludedSubmitOrderInfo(val) {
		this.formData.IsIncludedSubmitOrderInfo = val
		this.bunch({})
	}

	private calculateinventory(row) {
		// Stock 
		let two = /^\d+(\.\d{1,2})?$/
		if (row.ProductCount < 1 || row.ProductCount > 999 || !two.test(row.ProductCount)) {
			this.$message.error('只能填写1~999的整数')
			return
		}
		if (this.formData.ProductMixInfoList.every(v => v.ProductCount >= 1 && v.ProductCount <= 999)) {
			this.getstock()
		}
	}

	private getstock() {
		this.skuDetail[0].Stock = Math.min(...this.formData.ProductMixInfoList.map(v => Math.floor(v.Stock / v.ProductCount)))
		// console.log(this.formData.ProductMixInfoList)
	}

	private delcombination(row) {
		this.formData.ProductMixInfoList = this.formData.ProductMixInfoList.filter(v => {
			return row.ProductId != v.ProductId
		})
		if (!this.formData.ProductMixInfoList.length) {
			this.skuDetail = []
		} else {
			if (this.formData.ProductMixInfoList.every(v => v.ProductCount >= 1 && v.ProductCount <= 999)) {
				this.getstock()
			}
		}
	}

	private changeProductType() {
		this.formData.sku = []//规格参数
		this.skuDetail = []//设置价格那个详细表格数据
		this.searchName = ''//组合商品选中的Id
		this.searchList = []//组合商品查询的列表
		this.formData.ProductMixInfoList = []//组合商品的详细列表
		this.totalSku = {//批量修改的参数
			Stock: '', //库存
			Price: '', //原价
			GroupPrice: '', //团购价
			SpreadPrice: '', //差价
			ThirdRolePrice: '', //总代价
			RouTuanPrice: '', //肉团价
			lc_price: '',//联创
			core_price: '',//核心
		}
		this.formData.SpecImgSelectLeve = ''
		this.SharedDetail = []
		this.SharedtotalSku = []
		this.formData.IsShareStock = false
		this.formData.IsIncludedSubmitOrderInfo = false
		for (let i = 0; i < this.specificationsNum; i++) {
			let key = 'SpecTitle' + (i == 0 ? '' : i + 1)
			this.formData[key] = '';
		}
	}

	private pushProduct() {
		// console.log(this.searchName)
		if (this.isLook) {
			return
		}
		if (!this.searchName) {
			this.$message.error('请选择商品')
			return
		}
		this.formData.ProductMixInfoList.push({
			...this.searchList.find(v => v.ProductId == this.searchName),
			ProductCount: '',
		})
		this.searchList = this.searchList.filter(v => {
			return !this.formData.ProductMixInfoList.some(x => v.ProductId == x.ProductId)
		})
		this.skuNames = ['规格']
		if (!this.skuDetail.length) {
			this.skuDetail = [{
				Id: 0,
				SpecValue: '组合商品',
				SpecValue2: '',
				SpecValue3: '',
				ImgUrl: '',
				SellCount: '',
				Stock: '',
				Price: '',
				GroupPrice: '',
				SpreadPrice: '',
				ThirdRolePrice: '',
				RouTuanPrice: '',
				core_price: '',
				lc_price: '',
				IsCanSubmitOrder: true,
			}]
		}
		// console.log(this.formData.ProductMixInfoList,this.skuDetail)
		this.searchName = ''
		this.searchShop('')
	}

	private async searchShop(e) {
		try {
			this.searchLoading = true
			let data = {
				Skip: 0,
				Take: 999999,
				Keywords: await e,
				ProductType: 0,
			}
			let res = await productList(data)
			if (res.IsSuccess) {
				this.searchList = res.Result.Results.map(v => {
					v.ProductId = v.Id
					v.Id = 0
					return v
				}).filter(v => {
					return !this.formData.ProductMixInfoList.some(x => v.ProductId == x.ProductId)
				})
				// console.log(this.searchList)
				this.searchName = ''
			}
		} finally {
			this.searchLoading = false
		}
	}

	private validateNumber(e) {
		e.target.value = e.target.value.replace(/[^\d.]/g, '')
		e.target.value = e.target.value.replace(/\.{2,}/g, '.')
		e.target.value = e.target.value.replace(/^\./g, '0.')
		e.target.value = e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0, e.target.value.length -
			1))
		e.target.value = e.target.value.replace(/^0[^\.]+/g, '0')
		e.target.value = e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
		return e.target.value
	}

	private toBack() {
		this.$router.go(-1)
	}

	private toLogistics() {
		this.$router.push({
			name: 'Logistics_Template'
		})
	}
	private toLogistics2() {
		this.$router.push({
			path: 'settleFreight',
			query: {
				Id: this.$route.query.id,
				// ProviderId:row.ProviderId,
				Name: encodeURIComponent(this.formData.ProductName),
				Img: encodeURIComponent(this.formData.ImgUrlComplete[0]),
			}
		})
	}
	private changeroutuan(e, i) {
		//lc_price
		if (this.skuDetail[i].RouTuanPrice > this.skuDetail[i].lc_price) {
			this.skuDetail[i].RouTuanPrice = ''
			this.$message.error('公司拿货价需低于级别拿货价')
			return
		}
	}
	/**
	 * 获取单位列表
	 */
	private async getUnits() {
		try {
			const res: any = await productUnitList({});
			this.units = res.Result;
		} catch (err) {
			console.log(err)
		}
	}

	/**
	 * 获取商品分类
	 */
	private async getCategoryList() {
		try {
			const res: any = await productCategory({
				Skip: 0,
				Take: 99999
			});
			this.categoryList = res.Result.Results;
		} catch (err) {
			console.log(err)
		}
	}

	// 数据是否为空
	private isEmpty() {
		for (let key in this.formRule) {
			if (!String(this.formData[key]) || (Array.isArray(this.formData[key]) && !this.formData[key].length)) {
				this.$message({
					type: 'error',
					message: this.formRule[key]
				})
				return true
			}
		}
		for (let key in this.picRule) {
			if (!String(this.formData[key]) || (Array.isArray(this.formData[key]) && !this.formData[key].length)) {
				this.$message({
					type: 'error',
					message: this.picRule[key]
				})
				return true
			}
		}
		// console.log(this.formData.sku[0])
		if (this.formData.IsShareStock) {
			for (let item of this.formData.sku[0].sku_info) {
				// console.log(item.Count)
				if (item.Count < 1 || item.Count > 9999 || item.Count != parseInt(item.Count)) {
					this.$message({
						type: 'warning',
						message: '请输入正确的数量'
					})
					return true
				}
			}
		}
		if (this.formData.CrossErpType===8 && !this.formData.CrossErpJKYunProductType) {
			this.$message.error('请选择店铺')
			return true
		}
		if (this.formData.CrossErpType===3 && !this.formData.CrossErpEcinxProductType) {
			this.$message.error('请选择店铺')
			return true
		}
		if (this.formData.CrossErpType) {
			if (!this.formData.HuiFuProductId) {
				this.$message.error('跨境品请选择商品类别')
				return true
			}
		}
		
		let list = [
			{ key: 'Price', label: '原价不可小于0' },
			{ key: 'GroupPrice', label: '团购价不可小于0' },
			{ key: 'SpreadPrice', label: '差价不可小于0' },
			{ key: 'ThirdRolePrice', label: '总代价不可小于0' },
			{ key: 'core_price', label: '核心价不可小于0' },
			{ key: 'lc_price', label: '联创价不可小于0' },
			// {key:'RouTuanPrice',label:'肉团价不可小于0'},
		]
		//不计入交单
		if (!this.formData.IsIncludedSubmitOrderInfo) {
			for (let item of this.skuDetail) {
				// console.log(item)
				// return false
				for (let ele of list) {
					item[ele.key] = Number(item[ele.key])
					if (parseInt(item[ele.key]) < 0 || item[ele.key] === '') {
						this.$message.error(ele.label)
						return true
					}
					if (this.formData.CrossErpType) {
						if (!item.ProductSpecNo) {
							this.$message.error('跨境品对接erp，请输入规格编码')
							return true
						}
						if (!item.SaleCoefficient) {
							this.$message.error('跨境品请设置销售系数')
							return true
						}
					}
				}
			}
		} else {
			for (let item of this.SharedDetail) {
				for (let item2 of item) {
					for (let ele of list) {
						item2[ele.key] = Number(item2[ele.key])
						if (parseInt(item2[ele.key]) < 0 || item2[ele.key] === '') {
							this.$message.error(ele.label)
							return true
						}

						if (this.formData.CrossErpType) {
							if (!item2.ProductSpecNo) {
								this.$message.error('跨境品对接erp，请输入规格编码')
								return true
							}
							if (!item2.SaleCoefficient) {
								this.$message.error('跨境品请设置销售系数')
								return true
							}
						}
					}
				}
			}

		}
		// return true
		if (this.formData.IsExchangeBuyProduct && this.formData.ProductType == 1) {
			this.$message.error('组合商品不支持设置为换购商品')
			return true
		}
		if (this.formData.IsExchangeBuyProduct && this.formData.IsCanSearch) {
			this.$message.error('换购商品不开放单独购买，请关闭被搜索配置')
			return true
		}
		return false;
	}

	/**
	 * 添加规格
	 */
	private addSkus() {
		if (this.isLook) {
			return
		}
		if (this.formData.sku.length >= this.specificationsNum) {
			let list = ['一', '二', '三', '四', '五']
			this.$message(`最多添加${this.specificationsNum}个规格`);
			return false
		}

		let i = this.formData.sku.findIndex(item=>{
			return item.sku_name === '现货/预售';
		})

		if (i === this.formData.sku.length-1){
			this.formData.sku.splice(i, 0, {
				sku_name: '',
				sku_info: [],
				Sort: this.formData.sku.length + 1,
			});
		}else{
			this.formData.sku.push({
				sku_name: '',
				sku_info: [],
				Sort: this.formData.sku.length + 1,
			})
		}

		this.formData.sku.map((item, j) => {
			item.Sort = j + 1;
			return item;
		})
		
		this.isCover = true;
	}

	/**
	 * 删除规格
	 */
	private deleteSkus(obj: any) {
		this.formData.sku.splice(obj.index, 1);
		this.calcSku(obj)
		// this.formData.SpecImgSelectLeve = obj.picIndex;
		// console.log(this.formData.sku)
		this.bunch({ IsDel: true })
	}

	/**
	 * 计算生成sku
	 */
	private calcSku(obj: any) {
		if (obj.type && obj.type === 'delete') {
			this.isCover = true;
		}
		console.log(obj,11)
		this.formData.SpecImgSelectLeve = obj.picIndex;
		// console.log(obj)
		const list = obj.list;
		const skuList: any = [];
		const skuName: string[] = [];
		let tableListLength = 1
		let skuItem = {}
		this.formData.sku = [];
		list.length && list.map((item: any, index: number) => {
			if (item.sku_name) {
				skuName.push(item.sku_name);
			}
		})
		this.formData.sku = list;
		// console.log(list)
		this.skuNames = skuName;
		this.bunch(obj)
	}


	// 获取token
	private async getToken() {
		try {
			const res: any = await getOssToken({})
			this.token = {
				AccessKeySecret: res.access_key_secret,
				OSSAccessKeyId: res.access_key_id,
				SecurityToken: res.security_token
			}
		} catch (e) {
			console.error('getOssToken ===>', e)
		}
	}

	// 改变全部价格
	private changAllPricd2(e: any, oldtype: string, v: any, i: any) {
		let two = /^\d+(\.\d{1,2})?$/
		let type = oldtype
		let batchtype = 'SpecBacth' + type
		// console.log(type)
		//联创 核心字段跟接口不一样 转换一下
		let typeinfo = {
			'SecondRolePrice': 'core_price',
			'FirstRolePrice': 'lc_price'
		}
		type = typeinfo[oldtype] || oldtype
		// if (Number(this.SharedtotalSku[i][batchtype]) < 0 || !two.test(this.SharedtotalSku[i][batchtype])) {
		// 	this.SharedtotalSku[i][batchtype] = ''
		// 	return
		// }
		// if (type === 'GroupPrice' && !(this.SharedtotalSku[i][batchtype] > 0)) {
		// 	this.SharedtotalSku[i][batchtype] = ''
		// 	this.$message.error('下单价格不允许为0，请检查后重新保存')
		// 	return
		// }
		this.SharedDetail = this.SharedDetail.map((val, ind) => {
			if (ind == i) {
				for (let item of val) {
					item[type] = this.SharedtotalSku[i][batchtype];
					let oldpri = JSON.parse(JSON.stringify(item[type]))
					// console.log(item[type],this.SharedtotalSku[i][batchtype])
					if (type === 'core_price' || type === 'lc_price') {
						// 	let core_price = parseFloat(((item.ThirdRolePrice || 0) - (item.SpreadPrice || 0)).toFixed(2));
						// 	// console.log(core_price, 666)
						// 	// if (core_price < 0) {
						// 	// 	item[type] = oldpri
						// 	// 	this.SharedtotalSku[i][batchtype] = ''
						// 	// 	this.$message.error('核心价不可小于0')
						// 	// 	break
						// 	// }
						// 	let lc_price = parseFloat(((core_price || 0) - (item.SpreadPrice || 0)).toFixed(2));
						// 	// if (lc_price < 0) {
						// 	// 	item[type] = oldpri
						// 	// 	this.SharedtotalSku[i][batchtype] = ''
						// 	// 	this.$message.error('联创价不可小于0')
						// 	// 	break
						// 	// }
						// 	let RouTuanPrice = parseFloat(((lc_price || 0) - (item.SpreadPrice || 0)).toFixed(2));
						// 	// if (RouTuanPrice < 0) {
						// 	// 	item[type] = oldpri
						// 	// 	this.SharedtotalSku[i][batchtype] = ''
						// 	// 	this.$message.error('肉团价不可小于0')
						// 	// 	break
						// 	// }
						let SpreadPrice = parseFloat(((item.core_price || 0) - (item.lc_price || 0)).toFixed(2));
						if (SpreadPrice < 0) {
							item[type] = oldpri
							this.SharedtotalSku[i][batchtype] = ''
							this.$message.error('差价不可小于0')
							break
						}

						item.SpreadPrice = SpreadPrice
						// 	item.core_price = core_price
						// 	item.lc_price = lc_price
						// 	item.RouTuanPrice = RouTuanPrice
					}
				}
				// console.log(this.SharedDetail[i])
			}
			if (type == 'Stock') {
				this.SharedtotalSku = this.SharedtotalSku.map(v => {
					v[batchtype] = this.formData.IsShareStock ? this.SharedtotalSku[i][batchtype] : v[batchtype]
					return v
				})
				for (let item of val) {
					if (!this.formData.IsShareStock) break
					item[type] = this.SharedtotalSku[i][batchtype];
				}
			}
			return val
		})

		if (type === 'RouTuanPrice') {
			let isConform = false
			for (let list of this.SharedDetail) {
				for (let item of list) {
					if (item.lc_price < item.RouTuanPrice) {
						isConform = true
						break
					}
				}
			}
			if (isConform) {
				this.$message.error('公司拿货价需低于级别拿货价')
				this.SharedtotalSku[i][type] = ''
				this.SharedDetail = this.SharedDetail.map((v: any) => {
					v.map(x => {
						x.RouTuanPrice = ''
						return x
					})
					return v
				})
			}
		}
		if (type === 'preorder_num') {
			// this.changePreorderNum2();
		}
	}
	// 修改预售数量时 计算总数
	private changePreorderNum2() {
		this.formData.preorder_num = 0;
		this.skuDetail.map((item: any) => {
			this.formData.preorder_num += (+item.preorder_num || 0)
		})
	}

	// 改变全部价格
	private changAllPricd(e: any, type: string) {
		let two = /^\d+(\.\d{1,2})?$/
		// console.log(1)
		// console.log(this.totalSku[type])
		// console.log(this.totalSku[type], type)
		// if (Number(this.totalSku[type]) < 0 || !two.test(this.totalSku[type])) {
		// 	this.totalSku[type] = ''
		// 	return
		// }
		// if (type === 'GroupPrice' && !(this.totalSku[type] > 0)) {
		// 	this.totalSku[type] = ''
		// 	this.$message.error('下单价格不允许为0，请检查后重新保存')
		// 	return
		// }
		for (let item of this.skuDetail) {

			// this.skuDetail.map((item: any) => {
			let oldpri = JSON.parse(JSON.stringify(item[type]))
			// console.log(this.totalSku[type],item[type])
			item[type] = this.totalSku[type];
			// console.log(item[type],this.totalSku[type],type)
			if ((type === 'core_price' || type === 'lc_price')) {
				// 	let core_price = parseFloat(((item.ThirdRolePrice || 0) - (item.SpreadPrice || 0)).toFixed(2));
				// 	// console.log(core_price, 666)
				// 	// if (core_price < 0) {
				// 	// 	item[type] = oldpri
				// 	// 	this.totalSku[type] = ''
				// 	// 	this.$message.error('核心价不可小于0')
				// 	// 	break
				// 	// }
				// 	let lc_price = parseFloat(((core_price || 0) - (item.SpreadPrice || 0)).toFixed(2));
				// 	// if (lc_price < 0) {
				// 	// 	item[type] = oldpri
				// 	// 	this.totalSku[type] = ''
				// 	// 	this.$message.error('联创价不可小于0')
				// 	// 	break
				// 	// }
				// 	let RouTuanPrice = parseFloat(((lc_price || 0) - (item.SpreadPrice || 0)).toFixed(2));
				// 	// if (RouTuanPrice < 0) {
				// 	// 	item[type] = oldpri
				// 	// 	this.totalSku[type] = ''
				// 	// 	this.$message.error('肉团价不可小于0')
				// 	// 	break
				// 	// }


				let SpreadPrice = parseFloat(((item.core_price || 0) - (item.lc_price || 0)).toFixed(2));
				if (SpreadPrice < 0) {
					item[type] = oldpri
					this.totalSku[type] = ''
					this.$message.error('差价不可小于0')
					break
				}
				// console.log(this.totalSku[type])
				item.SpreadPrice = SpreadPrice
				// 	item.core_price = core_price
				// 	item.lc_price = lc_price
				// 	item.RouTuanPrice = RouTuanPrice
			}

			// item[type] = this.totalSku[type];
			// })
		}
		// console.log(this.skuDetail)
		// if(havereturn) return
		if (type === 'RouTuanPrice') {
			let isConform = false
			for (let item of this.skuDetail) {
				if (item.lc_price < item.RouTuanPrice) {
					isConform = true
					break
				}
			}
			if (isConform) {
				this.$message.error('公司拿货价需低于级别拿货价')
				this.totalSku[type] = ''
				this.skuDetail = this.skuDetail.map((v: any) => {
					v.RouTuanPrice = ''
					return v
				})
			}
		}
		if (type === 'preorder_num') {
			this.changePreorderNum();
		}
	}

	// 控制商品预购开关
	private changePreorder(e) {
		if (e) return
		// 当关闭开关直接清空设置的预售总数量
		this.formData.preorder_num = 0
		this.skuDetail.map((item: any) => {
			item.preorder_num = 0
		})
	}

	// 修改预售数量时 计算总数
	private changePreorderNum() {
		this.formData.preorder_num = 0;
		this.skuDetail.map((item: any) => {
			this.formData.preorder_num += (+item.preorder_num || 0)
		})
	}
	private wathhxlc2(e: any, index: number, i: number) {
		// console.log(i,index)
		let data: any = this.SharedDetail[i].map((v, ind) => {
			if (index == ind) {
				// console.log(v.core_price,v.lc_price)
				v.SpreadPrice = parseFloat(((v.core_price || 0) - (v.lc_price || 0)).toFixed(2));
			}
			return v
		})
		if (data.SpreadPrice < 0) {
			this.$message.error('差价不可小于0')
			data.SpreadPrice = ''
		}
		this.$set(this.SharedDetail, i, data);
	}
	// 改变核心联创的价格
	private wathhxlc(e: any, index: number) {
		let data: any = this.skuDetail[index]
		// console.log(index)
		// if (data.SpreadPrice && data.ThirdRolePrice) {
		// data.core_price = parseFloat(((data.ThirdRolePrice || 0) - (data.SpreadPrice || 0)).toFixed(2));
		// (+data.core_price < 0 && (data.core_price = 0))
		// data.lc_price = parseFloat(((data.core_price || 0) - (data.SpreadPrice || 0)).toFixed(2));
		// (+data.lc_price < 0 && (data.lc_price = 0))
		// data.RouTuanPrice = parseFloat(((data.lc_price || 0) - (data.SpreadPrice || 0)).toFixed(2));

		data.SpreadPrice = parseFloat(((data.core_price || 0) - (data.lc_price || 0)).toFixed(2));
		// console.log(data.SpreadPrice)

		// (+data.RouTuanPrice < 0 && (data.RouTuanPrice = 0))
		// if (data.core_price < 0) {
		// 	this.$message.error('核心价不可小于0')
		// 	return
		// }
		// if (data.lc_price < 0) {
		// 	this.$message.error('联创价不可小于0')
		// 	return
		// }
		// if (data.lc_price < 0) {
		// 	this.$message.error('肉团价不可小于0')
		// 	return
		// }
		// }

		if (data.SpreadPrice < 0) {
			this.$message.error('差价不可小于0')
			data.SpreadPrice = ''
		}
		this.$set(this.skuDetail, index, data);
	}


	// 获取供应商列表
	private async getSupplierList() {
		this.loadingSupplier = true;
		try {
			const res: any = await providerSelectItem({});
			this.supplierList = res.Result
			this.loadingSupplier = false;
		} catch (e) {
			this.loadingSupplier = false;
		}
	}

	// 获取最大的discount
	private getMaxDiscount() {
		let maxDiscount = 0
		this.formData.sku_params.map((detail: any) => {
			let discount = detail.discount
			if (maxDiscount < discount) {
				maxDiscount = discount
			}
		})
		return maxDiscount
	}

	private trimParams() {

		this.formData.sku_params = JSON.parse(JSON.stringify(this.skuDetail.map((v, i) => {
			v.Sort = i
			return v
		})))
		let params: any = JSON.parse(JSON.stringify(this.formData));
		params.Id = this.id || '';

		params.ProductClassId = params.ProductClassId.length ? params.ProductClassId[params.ProductClassId.length - 1] : ''

		params.ProductSpecList = this.skuDetail.map(v => {
			// console.log(v.lc_price,v.core_price,'456')
			v.FirstRolePrice = v.lc_price
			v.SecondRolePrice = v.core_price
			return v
		})
		// console.log(params.ProductSpecList)
		if (params.IsIncludedSubmitOrderInfo) {
			params.ProductSpecList = []
			this.SharedDetail.map(v => {
				v.map(x => {
					params.ProductSpecList.push(x)
				})
			})
		} else {
			params.ProductSpecList = this.skuDetail.map(v => {
				if (params.ProductType == 1) {
					v.Stock = 0
				}
				return v
			})
		}
		//获取图片index
		params.sku.map((v, i) => {
			v.sku_info && v.sku_info.length && v.sku_info.map(x => {
				if (x.pic_url) {
					console.log(x,i)
					params.SpecImgSelectLeve = i
					return
				}
			})
		})
		// console.log(params.ProductSpecList,2222)
		if (params.ProductType == 0) {
			params.ProductMixInfoList = []
			for (let i = 0; i < this.specificationsNum; i++) {
				let key = 'SpecTitle' + (i == 0 ? '' : i + 1)
				params[key] = this.formData.sku[i] ? this.formData.sku[i].sku_name : '';
			}
			params.SpecBacthDataList = this.SharedtotalSku
		} else if (params.ProductType == 1) {
			params.SpecTitle = '规格'
			params.IsIncludedSubmitOrderInfo = false
		}


		// params.SpecTitle = this.formData.sku[0] ? this.formData.sku[0].sku_name : '';
		// params.SpecTitle2 = this.formData.sku[1] ? this.formData.sku[1].sku_name : '';
		// params.SpecTitle3 = this.formData.sku[2] ? this.formData.sku[2].sku_name : '';

		params.ProductAuthPic = params.ProductAuthPic.filter(v => v)
		params.ProductSixFaceImgUrl = params.ProductSixFaceImgUrl.filter(v => v)

		// console.log(params.Video,1395);
		params.ProductThumbImgUrl = params.ProductThumbImgUrl[0];

		params.Video = params.Video.length ? params.Video[0] : '';

		params.SpecBacthStock = this.totalSku.Stock; //库存
		// params.SpecBacthSellCount = this.totalSku.Stock;//销量
		params.SpecBacthPrice = this.totalSku.Price; //原价
		params.SpecBacthGroupPrice = this.totalSku.GroupPrice; //团购价
		params.SpecBacthSpreadPrice = this.totalSku.SpreadPrice; //差价
		params.SpecBacthThirdRolePrice = this.totalSku.ThirdRolePrice; //总代价
		params.SpecBacthRouTuanPrice = this.totalSku.RouTuanPrice; //肉团价
		params.SpecBacthFirstRolePrice = this.totalSku.lc_price; //联创
		params.SpecBacthSecondRolePrice = this.totalSku.core_price; //核心

		params.Id = this.$route.query.type == 'copy' ? 0 : params.Id
		// console.log(params)
		return params;
	}

	/**
	 * 商品标签设置
	 */
	private handleCloseTag(index) {
		this.formData.ProductTags.splice(index, 1);
	}

	private showInput() {
		this.inputVisible = true;
		let nextTick: any = this.$nextTick;
		nextTick((obj: any) => {
			let refs: any = this.$refs;
			refs.saveTagInput.$refs.input.focus();
		});
	}

	private handleInputConfirm() {
		let inputValue = this.inputValue;
		if (inputValue) {
			this.formData.ProductTags.push(inputValue);
		}
		this.inputVisible = false;
		this.inputValue = '';
	}

	// 提交信息
	private async submit(needShowType?: Number) {

		// needShowType 需要依次校验弹窗 弹窗确定的按钮传下一个校验类型
		if (this.isEmpty()) {
			return;
		}
		let num = needShowType
		if (this.isButtjoint) {
			if (num == 1) {
				this.jushuitantips = true
				return
			}
		} else {
			if (num == 1) {
				num = 2
			}
		}
		if (!this.formData.IsHaveOrderFee) {
			if (num == 2) {
				this.ShowOpenService = true
				return
			}
		} else {
			if (num == 2) {
				num = 3
			}
		}

		if (this.formData.Id && this.type !== 'copy'){
			await this.checkIsChangeSku();
		}
		this.showMessage = true;
	}
	private checkIsChangeSku(){
		return new Promise(async (resolve, reject)=>{
			try {
				let params = this.trimParams();
				const res: any = await productChangeSpecAndJoinActivityOnePrice({
					ProductId: this.formData.Id,
					ProductSpecList: params.ProductSpecList
				});
				if (res.Result.IsChangeSpecToActivityOnePrice){
					this.skuChangeTips = true;
					this.activityName = res.Result.ActivityNames;
					reject();
				}else{
					resolve(true);
				}
			} catch (e) {
				resolve(true);
			}
		})
	}

	private getImageWidthAndHeight(url){
		return new Promise((resolve, reject)=>{
			let imageUrl = this.url + url;
			let image = new Image();
			image.onload = function(){
				resolve({
					width: image.width,
					height: image.height
				});
			}
			image.onerror = function(){
				resolve({
					width: 0,
					height: 0
				});
			}
			image.src = imageUrl;
		})
		
	}

	private handleConfirm() {
		this.doCreate()
	}

	// 创建商品
	private async doCreate() {
		let params = this.trimParams();
		// console.log(params)
		// console.log(params.ProductSpecList,'123')
		// return
		try {
			// let data = {
			// 	...
			// }
			// console.log(params.SpecImgSelectLeve,params)

			if (this.formData.NoWatermarkImgUrl.length && this.templateUrl){
				// setTimeout(this.getCanvasImage, 500)
				const url = await this.getCanvasImage();
				params.ImgUrl[0] = url;
			}
			let imgUrlInfo: any = await this.getImageWidthAndHeight(params.ImgUrl[0]);
			let thumbImgUrlInfo: any = await this.getImageWidthAndHeight(params.ProductThumbImgUrl);
			params.ImgUrlWidth = imgUrlInfo.width;
			params.ImgUrlHeight = imgUrlInfo.height;
			params.ProductThumbImgUrlWidth = thumbImgUrlInfo.width;
			params.ProductThumbImgUrlHeight = thumbImgUrlInfo.height;
			console.log(imgUrlInfo,thumbImgUrlInfo)

			let ref = (this as any).$refs.productPictures;
			if (ref) {
				params.HotSpotConfig = JSON.stringify(ref.areaList)
			}

			let res = await createProduct({
				ProductInfo: params,
				IsProviderCheckEdit: this.$route.query.identity == 'supplier',
				noError: true
			})
			if (res.IsSuccess) {
				this.$message({
					type: 'success',
					message: '操作成功'
				})
				this.toBack()
				// console.log(res)
			} else {
				if (res.ErrorCode == 40000001 || res.ErrorCode == 40000002) {
					this.errorTipsShow = true
					this.errorType = res.ErrorCode
				} else if (res.ErrorCode == 40000003) {
					this.delTipShow = true
				} else {
					this.$message.error(res.Message)
				}
			}
		} catch (e) {
			//
		}
	}


	private async getInfo() {
		try {
			// console.log(1)
			const res: any = await productInfo({
				Id: this.id
			})
			this.isPageLoading = false;
			const skuMap = {};
			// this.skus = []
			this.formData.sku = [];
			this.skuNames = []

			//计算规格类型列表
			for (let i = 0; i < this.specificationsNum; i++) {
				let key = 'SpecTitle' + (i == 0 ? '' : i + 1)
				if (res.Result[key]) {
					this.formData.sku.push({
						sku_name: res.Result[key],
						sku_info: [],
						key: Math.random(),
						Sort: i + 1,
					})
					this.skuNames.push(res.Result[key])
				}
			}

			if (res.Result.HotSpotConfig) {
				try {
					this.hotData = JSON.parse(res.Result.HotSpotConfig)
				} catch (error) {

				}
			}

			if (this.type !== 'copy'){
				if (res.Result.ProductImgTemplateId){
					let list = this.templates.filter(item=>{
						return item.Id === res.Result.ProductImgTemplateId;
					})
					if (!list.length){
						res.Result.ProductImgTemplateId =  null;
					}
				}else{
					res.Result.ProductImgTemplateId =  null;
				}
			}
			if (res.Result.ProductImgTemplateId === 0){
				res.Result.ProductImgTemplateId =  null;
			}
			if (res.Result.CrossErpJKYunProductType === 0){
				res.Result.CrossErpJKYunProductType =  null;
			}
			if (res.Result.CrossErpEcinxProductType === 0){
				res.Result.CrossErpEcinxProductType =  null;
			}
			
			if (!res.Result.ProductImgTemplateId && res.Result.NoWatermarkImgUrl?.length){
				res.Result.ImgUrl = res.Result.NoWatermarkImgUrl;
			}
			if (!res.Result.NoWatermarkImgUrl?.length){
				res.Result.NoWatermarkImgUrl = res.Result.ImgUrl;
			}

			if (res.Result.ProductSpecList && res.Result.ProductSpecList.length) {
				res.Result.ProductSpecList.forEach((item: any, index: number) => {

					if (this.$route.query.type == 'copy') {
						item.Id = 0;
					}

					item.core_price = item.SecondRolePrice
					item.lc_price = item.FirstRolePrice
					//肉团价可修改 所以初始化时不计算
					// item.RouTuanPrice = parseFloat(((item.lc_price||0) - (item.SpreadPrice||0)).toFixed(2));

					//计算规格型号列表

					for (let i = 0; i < this.specificationsNum; i++) {
						let key = 'SpecValue' + (i == 0 ? '' : i + 1)
						if (item[key] && this.formData.sku[i]) {
							var have = null;
							let haveIndex = -1;
							this.formData.sku[i].sku_info.map((obj: any, index: number) => {
								if (obj.sku_value === item[key]) {
									have = obj;
									haveIndex = index;
								}
							})
							// console.log(item,i,res.Result.SpecImgSelectLeve)
							if (!have) {
								let data = {
									pic_url: '',
									sku_value: item[key],
									sku_id: item.Id,
									sku_ids: [item.Id],
									isNew: false,
									classKey: Math.random(),
									//只有第一层级的规格才会有
									Count: i == 0 ? item.Count : '',
									IsCanSubmitOrder: item.IsCanSubmitOrder && i == 0 ? item.IsCanSubmitOrder : false,
								}
								// console.log(item.Count,'data')
								this.formData.sku[i].sku_info.push(data)

								if (i == res.Result.SpecImgSelectLeve) {
									this.formData.sku[i].sku_info[this.formData.sku[i].sku_info.length - 1].pic_url = item.ImgUrl || ''
								}
							} else {
								this.formData.sku[i].sku_info[haveIndex].sku_ids.push(item.Id);
							}
						}
					}
					if (this.$route.query.type == 'copy') {
						item.SellCount = 0
					}
				})
			}
			// console.log(this.formData.sku)
			this.$forceUpdate()
			this.skuDetail = res.Result.ProductSpecList;
			if (res.Result.ProductType == 1) {
				this.skuDetail[0].Stock = Math.min(...res.Result.ProductMixInfoList.map(v => Math.floor(v.Stock / v.ProductCount)))
			} else {
				this.formData.IsShareStock = res.Result.IsShareStock
				//这里要先赋值 不然函数里拿不到值 数量没有赋上去
				this.bunch({ isInfo: true })
				// this.getskuDetail(this.formData.sku,res.Result.ProductSpecList)
			}
			// console.log(this.skuDetail,1587,res.Result.ProductSpecList)
			// console.log(res.Result.ProductThumbImgUrl,123)
			res.Result.ProductThumbImgUrl = res.Result.ProductThumbImgUrl ? [res.Result.ProductThumbImgUrl] : [];
			res.Result.Video = res.Result.Video ? [res.Result.Video] : [];

			this.canopengroup = new Date(res.Result.OpenTime).getTime() < new Date().getTime() && this.$route.query
				.type != 'copy'

			this.novolume = res.Result.ProductSpecList.every(v => v.SellCount == 0)

			this.SharedtotalSku = res.Result.SpecBacthDataList
			// console.log(this.SharedtotalSku)

			for (let item in res.Result) {
				this.formData[item] = res.Result[item];
			}
			this.formData.CrossErpType = this.formData.CrossErpType || ''
			this.formData.HuiFuProductId = this.formData.HuiFuProductId || ''
			this.formData.FreightSettlementTemplateId = this.formData.FreightSettlementTemplateId || ''
			this.formData.FreightTemplateId = this.formData.FreightTemplateId || ''
			// this.formData.ProductCheckState = 6FreightTemplateId
			// console.log(this.formData.ProductCheckState)
			this.formData.ProductBuyerId = this.formData.ProductBuyerId || null
			this.formData.OwnBrandProductId = this.formData.OwnBrandProductId || ''
			let totalSku = {
				Stock: res.Result.SpecBacthStock, //库存
				Price: res.Result.SpecBacthPrice, //原价
				GroupPrice: res.Result.SpecBacthGroupPrice, //团购价
				SpreadPrice: res.Result.SpecBacthSpreadPrice, //差价
				ThirdRolePrice: res.Result.SpecBacthThirdRolePrice, //总代价
				RouTuanPrice: res.Result.SpecBacthRouTuanPrice, //肉团价
				lc_price: res.Result.SpecBacthFirstRolePrice, //联创
				core_price: res.Result.SpecBacthSecondRolePrice, //核心
			}
			// console.log(totalSku,res.Result.SpecBacthFirstRolePrice,res.Result.SpecBacthSecondRolePrice)
			this.copytotalSku = totalSku
			this.totalSku = totalSku
			// console.log(this.formData.ProductClassId,111)
			this.getClassId()
			this.getRefundAddressByID(res.Result.ProviderReturnAddressId)
			this.getLogisticsList();
			this.getLogisticsList2();
			this.querySelectChange();
		} catch (e) {
			console.log(e)
			this.isPageLoading = false;
		}
	}

	private getClassId() {
		let id = this.formData.ProductClassId
		for (let item of this.categoryoptions) {
			if (item.Id == id) {
				this.formData.ProductClassId = [item.Id]
				return
			} else if (item.children && item.children.length) {
				for (let item2 of item.children) {
					if (item2.Id == id) {
						this.formData.ProductClassId = [item.Id, item2.Id]
						return
					} else if (item2.children && item2.children.length) {
						for (let item3 of item2.children) {
							if (item3.Id == id) {
								this.formData.ProductClassId = [item.Id, item2.Id, item3.Id]
								return
							}
						}
					} else {
						this.formData.ProductClassId = []
						continue
					}
				}
			} else {
				this.formData.ProductClassId = []
				continue
			}
		}
	}

	private getskuDetail(sku: any, dellist: any) {
		let list: any = []
		dellist.map((j: any) => {
			// console.log(m)
			let num = 0
			let classKey = ''
			for (let i = 0; i < sku.length; i++) {
				info: for (let m = 0; m < sku[i].sku_info.length; m++) {
					let key = 'SpecValue' + (i == 0 ? '' : i + 1)
					if (j[key] == sku[i].sku_info[m].sku_value) {
						num += 1
						classKey += sku[i].sku_info[m].classKey
						break info
					}
				}
			}
			//查找到对应的规格型号对应的数据 并且拼接上每个对应规格型号的classKey
			if (num == sku.length) {
				j.classKey = classKey
				list.push(j)
			}
		})
		this.skuDetail = list
		// console.log(this.skuDetail)
	}

	// 上传图片成功回调
	private uploadSuc(list: any, key: string) {
		// console.log(list,key)
		// if (key === 'ProductThumbImgUrl' || key === 'Video'){
		// 	this.formData[key] = []
		// 	return 
		// }else{
		// 	this.formData[key] = list
		// }
		// if(key === 'Video'){
		// 	this.formData[key] = ''
		// 	return 
		// }
		// console.log(key)
		this.formData[key] = list

	}

	// 选择退款地址
	private selectRefundAddress(row: any) {
		this.formData.ProviderReturnAddressId = row.Id;
		this.selectRA = row;
		this.showSelectRefundAddress = false
	}

	// 通过id获取退款地址
	private async getRefundAddressByID(id: number) {
		if (!id) return;
		// let params: any = {
		// 	page_no: 1,
		// 	page_size: 10,
		// 	id: id
		// }
		// try {
		// 	const res: any = await getProviderReturnLogistics(params);
		// 	this.selectRA = res.info[0]
		// } catch (e) {
		// 	console.log(e)
		// }
		try {
			const res: any = await providerReturnAddressSelectItem({
				ProviderId: this.formData.ProviderId
			});
			var list = res.Result.filter(item => {
				return item.Id == id;
			})
			this.selectRA = list.length ? list[0] : null;
		} catch (e) {
			console.log(e)
		}
	}

	//修改供应商 清空物流模板
	private changeProviderId(e) {
		this.formData.FreightTemplateId = null
		this.formData.ProviderReturnAddressId = null
		this.selectRA = null
		let msg = this.supplierList.find(v => v.Id == e)
		this.isButtjoint = msg?.IsUserJuShuiTan || false
		this.getLogisticsList()
	}

	/**
	 * 跳转到供应商模版列表
	 */
	private async getLogisticsList() {


		try {
			// console.log(this.formData.provider_id)
			const res: any = await productfreightTemplateSelectitem({
				ProviderId: this.formData.ProviderId,
				Skip: 0,
				Take: 99999
			})
			this.logisticsList = res.Result;
			// this.logisticsList.unshift({
			// 	tpl_name: '全国包邮',
			// 	tpl_id: 0
			// })
		} catch (err) {
			console.log(err);
		}
	}
	//结算模板
	private async getLogisticsList2() {


		try {
			// console.log(this.formData.provider_id)
			const res: any = await freightSettlementTemplatefreightSettlementTemplateList({
				ProviderId: this.formData.ProviderId,
				ProductId: this.formData.id,
			})
			this.logisticsList2 = res.Result;
			// this.logisticsList.unshift({
			// 	tpl_name: '全国包邮',
			// 	tpl_id: 0
			// })
		} catch (err) {
			console.log(err);
		}
	}

	/**
	 * 监听时间修改
	 */
	private changeTime(e: any, type: string) {
		if (type === 'start') {
			if (this.formData.TakedownTime && getTimestamp(e) > getTimestamp(this.formData.TakedownTime)) {
				this.$message({
					type: 'warning',
					message: '上架时间不能大于结束时间'
				})
				this.formData.OpenTime = ''
				return;
			}
			// if (this.formData.preorder_time && e < this.formData.preorder_time) {
			// 	this.$message({
			// 		type: 'warning',
			// 		message: '上架时间不能小于预告时间'
			// 	})
			// 	this.formData.pd_begin_time = ''
			// 	return;
			// }
		} else if (type === 'end') {
			if (this.formData.OpenTime && getTimestamp(e) < getTimestamp(this.formData.OpenTime)) {
				this.$message({
					type: 'warning',
					message: '结束时间不能小于上架时间和预告时间'
				})
				this.formData.TakedownTime = ''
				return;
			}
		} else if (type === 'pre') {
			// if ((this.formData.pd_begin_time && e > this.formData.pd_begin_time) || (this.formData.pd_end_time &&
			// 		e > this
			// 		.formData.pd_end_time)) {
			// 	this.$message({
			// 		type: 'warning',
			// 		message: '预告时间不能大于上架时间和结束时间'
			// 	})
			// 	this.formData.preorder_time = ''
			// 	return;
			// }
		}
	}

	/**
	 * 修改限购与起购数
	 */
	private onChangeBuyNum(e: any, type: string) {
		if (this.formData.BuyLimit && (parseInt(this.formData.BuyLimit) < parseInt(this.formData.MinPurchase))) {
			this.$message({
				type: 'warning',
				message: '最低起购数不能大于购买限制'
			})
			this.formData[type] = ''
			return;
		}
	}
}
